<script setup lang="ts">
import CircularProgress from '@/uiKit/CircularProgress.vue'
import HighlightedTextarea from '@/uiKit/HighlightedTextarea.vue'
import { useQuery } from '@tanstack/vue-query'

/**
 * In a number of places in the frontend, we render a file inline. This component
 * is a wrapper around the different file types that can be rendered inline.
 * Eventually this should probably be a registry, but for now the child component
 * signatures are different enough that it's not worth it. We should look to
 * refactor this in the future if more inline file types are added.
 */
const props = defineProps<{
  url: string
  fileType: 'txt' | 'json'
}>()

const { data, isLoading } = useQuery({
  queryKey: ['text-file-content', props.url],
  queryFn: async () => {
    const response = await fetch(props.url)
    if (!response.ok) {
      throw new Error(`Failed to fetch file content from ${props.url}`)
    }
    return response.text()
  },
})
</script>

<template>
  <div
    v-if="isLoading"
    class="flex h-screen items-center justify-center"
  >
    <CircularProgress />
  </div>
  <div
    class="go-scrollbar max-w-full overflow-auto px-1.5 pb-2 text-sm-12px-light whitespace-normal text-text"
  >
    <template v-if="fileType === 'txt'">{{ data }}</template>
    <HighlightedTextarea
      v-else-if="fileType === 'json'"
      :value="data || ''"
      lang="json"
      variant="transparent"
    />
  </div>
</template>
